import { IProcesso } from "../../../interfaces/processo.interface";
import Botao from "../../Botao";
import PieChart from "../../PieChart";

import styles from './SectionGastosProdutivos.module.scss';

export default function SectionGastosProdutivos({ processo, voltar }: { processo: IProcesso | undefined; voltar: () => void }) {

    // Função para somar todas as despesas
    const somaDespesas = () => {
        if (!processo) return 0; // Se o processo for undefined, retorna 0
        return (
            processo.despesaMadeira +
            processo.despesaEnergia +
            processo.despesaMaquina +
            processo.despesaColaborador +
            processo.despesaInsumos
        );
    };

    return (
        <section className={styles.container}>
            <div className={styles.cabecalho}>
                <h1>Despesas: {processo?.produto}</h1>
                <Botao text={'Voltar'} onClick={voltar} style="blue"/>
            </div>
            <p>Matéria-prima: <span>R${processo?.despesaMadeira.toFixed(2)}</span></p>
            <p>Energia: <span>R${processo?.despesaEnergia.toFixed(2)}</span></p>
            <p>Depreciação de Máquina: <span>R${processo?.despesaMaquina.toFixed(2)}</span></p>
            <p>Salário Colaborador: <span>R${processo?.despesaColaborador.toFixed(2)}</span></p>
            <p>Insumos: <span>R${processo?.despesaInsumos.toFixed(2)}</span></p>
            <h3>Total de Despesas: <span>R${somaDespesas().toFixed(2)}</span></h3>
            <PieChart processo={processo} />
        </section>
    );
}
